import { CREATE_LISTINGS } from '@/constants/apiRoutes';
import { post } from '@/utilities/onwardClient';

export const createListings = async (body = {}) => {
    return post(CREATE_LISTINGS, body);
};
